import { useContext } from 'react';
import { useEgressPermissionService } from '../../utils/useEgressPermissionService';
import { RendererContext } from '../../context';
var isLocalImage = function isLocalImage(url, iframeDomainName) {
  if (!iframeDomainName) {
    return false;
  }
  var imageSrcUrl;
  try {
    imageSrcUrl = new URL(url);
    return iframeDomainName === imageSrcUrl.host;
  } catch (e) {
    return false;
  }
};
export var useIsValidImageUrl = function useIsValidImageUrl(url) {
  var _useContext = useContext(RendererContext),
    egress = _useContext.egress,
    appDomainName = _useContext.appDomainName;
  var dataImageUrlRegex = /^data:image/;
  var egressService = useEgressPermissionService('IMAGES', egress);
  try {
    var isValidUrl = isLocalImage(url, appDomainName) || dataImageUrlRegex.test(url) || egressService.isValidUrl(url);
    return isValidUrl;
  } catch (e) {
    return false;
  }
};